import React from 'react';
import { baseUrl } from '../url';
import Modal from '../modal/Modal';
import AddEditContacts from './AddEditContacts';
import loader from '../../assets/loader.svg';

class MoreInformation extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            contactPersons: [],
            show: false,
            response: false,
            details: this.props.details
        }
        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.fetchContacts =  this.fetchContacts.bind(this);
    }
    componentDidMount(){
        this.fetchContacts();
    }
    fetchContacts(){
        let token = localStorage.getItem('access_token'),
            id = this.props.id;
        fetch(`${baseUrl}/admin/patients/contacts/${id}`,{
            method: 'GET',
            headers: {
                'Authorization': token
            },
        })
        .then((response) => {
            const auth = response.headers.get('Authorization');
            localStorage.setItem('access_token', auth);
            return response.json();
        })
        .then((responseJson) => {
            this.setState({
                contactPersons: responseJson.data,
                response: true
            })
        })
    }
    showModal(){
        this.setState({ show: true });

    }
    hideModal(){
        this.setState({ show: false },this.fetchContacts());
        this.props.checkContacts()
    }
    render(){
        let { details } = this.state
        let address = details.bio.address.replace(/\b\w/g, l => l.toUpperCase());
        return(
            <div className="more-information">
                <div className="row">
                    <div className="col-sm-4">
                        <div className="card patient">
                            <div>
                                <h6>Address</h6>
                                <p>{address}</p>
                            </div>
                            <div>
                                <h6>Occupation</h6>
                                <p>{details.bio.occupation}</p>
                            </div>
                            <div>
                                <h6>Number of children less than 6 years</h6>
                                <p>{details.hospital_record.no_of_children}</p>
                            </div>
                            <div>
                                <h6>History of intake of Tuberculosis drugs</h6>
                                <p>{details.hospital_record.history_of_intake} weeks</p>
                            </div>
                            <div>
                                <h6>Who referred patient</h6>
                                <p>{details.hospital_record.referral}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-8">
                        <div className="card">
                        {
                            this.state.contactPersons.length !== 0 &&
                            <button className="edit-btn" onClick={() => this.showModal()}>Edit</button>
                        }
                            <h6 className="purple">Contact Person(s)</h6>
                            <div className="row">
                                {
                                    !this.state.response &&
                                    <div className="loader">
                                        <img src={loader} alt=""/>
                                    </div>
                                }
                                {
                                    this.state.contactPersons.length === 0 && this.state.response &&
                                    <div className="add-contacts">
                                        <p>No contact person(s) has been added</p>
                                        <button onClick={() => this.showModal()}><i className="fa fa-plus-circle"></i>Add Contact Persons</button>
                                    </div>
                                }
                                {
                                    this.state.contactPersons.length > 0 && this.state.response &&
                                    this.state.contactPersons.map(person => {
                                        let cAddress = person.address.replace(/\b\w/g, l => l.toUpperCase());
                                        return(
                                            <div className="col-sm-6" key={person.id}>
                                                <div className="contact">
                                                    <div>
                                                        <h6>Name</h6>
                                                        <p>{person.name}</p>
                                                    </div>
                                                    <div>
                                                        <h6>Phone number</h6>
                                                        <p>{person.phone_no}</p>
                                                    </div>
                                                    <div>
                                                        <h6>Email address</h6>
                                                        <p>{person.email}</p>
                                                    </div>
                                                    <div>
                                                        <h6>Address</h6>
                                                        <p>{cAddress}</p>
                                                    </div>
                                                </div>
                                            </div> 
                                        )
                                    })
                                }
                                <Modal show={this.state.show} handleClose={this.hideModal}>
                                    {this.state.show && <AddEditContacts handleClose={this.hideModal} id={this.props.id} contactPersons={this.state.contactPersons}/>}
                                </Modal>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default MoreInformation;


// WEBPACK FOOTER //
// ./src/components/patientProfile/MoreInformation.js